<div class="timeline-wrapper">
  <div class="timeline-toolbar">
    <div class="timeline-title-row">
      <i class="pi pi-clock"></i>
      <span class="timeline-title">Historial del cliente</span>
    </div>
    <div class="timeline-filters">
      <p-multiSelect [options]="categoryOptions" [(ngModel)]="selectedCategories" optionLabel="label" optionValue="value" placeholder="Categoría" (onChange)="onFilterChange()" [style]="{ minWidth: '14rem' }"></p-multiSelect>
      <p-calendar [(ngModel)]="dateRange" selectionMode="range" [readonlyInput]="true" placeholder="Rango de fechas" (onSelect)="onFilterChange()"></p-calendar>
    </div>
  </div>

  <!-- Carga localizada: solo el área del historial, nunca la página completa -->
  <div class="timeline-loading" *ngIf="loading$ | async">
    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" ariaLabel="Cargando historial"></p-progressSpinner>
    <span>Cargando historial…</span>
  </div>

  <ng-container *ngIf="!(loading$ | async)">
    <div class="empty-state" *ngIf="(events$ | async)?.length === 0">
      <i class="pi pi-history"></i>
      <p>Sin actividad registrada para este cliente todavía.</p>
    </div>

    <p-timeline *ngIf="(events$ | async) as events" [value]="events" align="left" styleClass="omnichannel-tl">
      <ng-template pTemplate="marker" let-event>
        <span class="timeline-marker" [ngClass]="markerClass(event.type)">
          <i [class]="markerIcon(event.type)"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-event>
        <app-timeline-event-item [event]="event"></app-timeline-event-item>
      </ng-template>
    </p-timeline>

    <div class="load-more-row" *ngIf="hasMore">
      <button pButton type="button" label="Cargar más" icon="pi pi-arrow-down" class="p-button-text p-button-sm" [loading]="(loadingMore$ | async) ?? false" (click)="loadMore()"></button>
    </div>
  </ng-container>
</div>
